// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__1nJol","column":"style_column__1xCfQ","row":"style_row__3RonC"};